// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yeucxlysxusaaquhzvjt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlldWN4bHlzeHVzYWFxdWh6dmp0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwOTc4MDQsImV4cCI6MjA3MDY3MzgwNH0.D0DBklBL8gMoZ63Y-CHrDlwnlFx78i1_2QapqwV1vN0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});